import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {

  [ModulesConfigMap[ModulesMap.FUEL_STATIONS].GET_FUEL_STATIONS]: {
    url: '/company/:companyId/fuel_stations/stations/',

  },
  [ModulesConfigMap[ModulesMap.FUEL_STATIONS].POST_FUEL_STATION]: {
    url: '/company/:companyId/fuel_stations/stations/',
    requestOptions: {
      method: 'POST',
    },
  },
  [ModulesConfigMap[ModulesMap.FUEL_STATIONS].GET_FUEL_STATION]: {
    url: '/company/:companyId/fuel_stations/stations/:fuelStationId/',

  },
  [ModulesConfigMap[ModulesMap.FUEL_STATIONS].GET_FUEL_STATION_POPUP]: {
    url: '/company/:companyId/fuel_stations/stations/:fuelStationId/popup/',

  },
  [ModulesConfigMap[ModulesMap.FUEL_STATIONS].GET_FUEL_STATION_PREVIEW]: {
    url: '/company/:companyId/fuel_stations/stations/:fuelStationId/preview/',

  },
  [ModulesConfigMap[ModulesMap.FUEL_STATIONS].PUT_FUEL_STATION]: {
    url: '/company/:companyId/fuel_stations/stations/:fuelStationId/',
    requestOptions: {
      method: 'PUT',
    },
  },
  [ModulesConfigMap[ModulesMap.FUEL_STATIONS].PATCH_FUEL_STATION]: {
    url: '/company/:companyId/fuel_stations/stations/:fuelStationId/',
    requestOptions: {
      method: 'PATCH',
    },
  },
  [ModulesConfigMap[ModulesMap.FUEL_STATIONS].DELETE_FUEL_STATION]: {
    url: '/company/:companyId/fuel_stations/stations/:fuelStationId/',
    requestOptions: {
      method: 'DELETE',
    },
  },
}
